import { types } from './constants';

export const changeCalendarDay = (selectedDay) => ({
  type: types.SELECTED_DAY_CHANGED,
  selectedDay,
});

export const changeCategory = (selectedCategory) => ({
  type: types.SELECTED_CATEGORY_CHANGED,
  selectedCategory,
});

export const selectedProgramItem = ({
  selectedEpgId,
  selectedProgramItem,
}) => ({
  type: types.SELECTED_PROGRAM_ITEM,
  selectedEpgId,
  selectedProgramItem,
});

export const deselectedProgramItem = () => ({
  type: types.DESELECTED_PROGRAM_ITEM,
});

export const fetchBroadcastContentEPGData = (contentID, epgID, from, to) => ({
  type: types.EPG_DATA_FETCH,
  contentID,
  epgID,
  from,
  to,
});

export const loadEPGDataFetchFailure = (errors) => ({
  type: types.EPG_DATA_FETCH_FAILURE,
  errors,
});

export const loadEPGDataFetchSuccess = (epgDataItems) => ({
  type: types.EPG_DATA_FETCH_SUCCESS,
  epgDataItems,
});

export const loadEPGDataIds = (dataIds) => ({
  type: types.EPG_DATA_ID,
  dataIds,
});

export const loadInputSearch = (inputSearch) => ({
  type: types.EPG_INPUT_SEARCH,
  inputSearch,
});

export const loadSwiperSlideLength = (swiperSlideLength) => ({
  type: types.EPG_SWIPER_SLIDE_LENGTH,
  swiperSlideLength,
});

export const loadSwiperSlidesPerView = (swiperSlidesPerView) => ({
  type: types.EPG_SWIPER_SLIDE_PER_VIEW,
  swiperSlidesPerView,
});

export const loadTimeListInDay = (timeListInDay) => ({
  type: types.EPG_TIME_LIST_IN_DAY,
  timeListInDay,
});

export const loadCurrentTime = (currentTime) => ({
  type: types.EPG_CURRENT_TIME,
  currentTime,
});

export const loadSwiperVirtualSizePxWidth = (swiperVirtualSizePxWidth) => ({
  type: types.EPG_SWIPER_VIRTUAL_SIZE_PX_WIDTH,
  swiperVirtualSizePxWidth,
});

export const changeBroadcastLive = (broadcastLiveBool) => ({
  type: types.EPG_BRODCAST_LIVE,
  broadcastLive: broadcastLiveBool,
});
